module.exports = __webpack_public_path__ + "img/HANHUA-FPD.44d24b4f.png";